module.exports = __webpack_public_path__ + "static/media/portfolio.7ed65e92.jpg";